import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import whatsappImage from "../../assets/images/Decorations/whatsapp-1.png";
const QuickScroller = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollY = window.scrollY; // Get vertical scroll position
    const firstSectionHeight =
      document.getElementById("first-section")?.offsetHeight || 0;

    if (scrollY > firstSectionHeight) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const clickScroller = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {/* {isVisible && (
        <a
          href="https://wa.me/1234567890"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-32 right-10 z-20 animate-pulse shadow-lg"
        >
          <img
            src={whatsappImage}
            alt="WhatsApp"
            className="h-12 w-12 object-cover lg:ml-2 rounded-sm"
          />
        </a>
      )} */}

      <div className="flex justify-end">
        {isVisible && (
          <motion.button
            onClick={clickScroller}
            className="fixed bottom-10 right-10 p-2 rounded-full z-20 animate-bounce bg-customBeige-50 border-2 shadow-lg"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="40px"
              viewBox="0 -960 960 960"
              width="30px"
              fill="#FFFFFF"
            >
              <path d="M446.67-160v-513l-240 240L160-480l320-320 320 320-46.67 47-240-240v513h-66.66Z" />
            </svg>
          </motion.button>
        )}
      </div>
    </>
  );
};

export default QuickScroller;
